// Toolbar that exposes the breakpoints present in the active target's
// captures. Click selects which resolution the grid renders side-by-side.
// Order follows the legacy numeric prefix in the resolution name
// (01-desktop-1920, 02-desktop-1440, ...).

import { For, Show } from 'solid-js';
import { actions, stores } from '../state/store';

function distinctResolutionsSorted(): string[] {
  const set = new Set<string>();
  for (const c of stores.state.captures) set.add(c.resolutionName);
  return [...set].sort();
}

// Legacy stbarts resolution-bar shows "<width>px" not the slug. Parse the
// width from the trailing number of the resolution name (e.g. "01-desktop-1920" → 1920).
function widthLabel(name: string): string {
  const m = name.match(/(\d+)$/);
  return m ? `${m[1]}px` : name;
}

export function ResolutionsSelector() {
  const resolutions = () => distinctResolutionsSorted();
  return (
    <Show when={stores.state.activeTargetId && resolutions().length > 0}>
      <div class="resolution-bar" role="toolbar" aria-label="Resolutions">
        <For each={resolutions()}>
          {(name) => (
            <button
              type="button"
              class={stores.state.activeResolution === name ? 'active' : ''}
              onClick={() => actions.setActiveResolution(name)}
              title={name}
            >
              {widthLabel(name)}
            </button>
          )}
        </For>
      </div>
    </Show>
  );
}
